"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachedFileImagePreview = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../../../../..");
const StyledImage = styled_components_1.default.img `
    width: 38px;
    height: auto;
    border-radius: 4px;
    margin-right: 4px;
`;
const OTHER_IMG_TYPES = ["image/tiff", "image/tiff2"];
const DOC_FILE_TYPES = ["pdf", "doc", "text"];
const AttachedFileImagePreview = ({ file, }) => {
    const fileType = file.file.type;
    const isPdfOrDoc = DOC_FILE_TYPES.some((file) => fileType.includes(file));
    const isImgFileWithoutPreview = OTHER_IMG_TYPES.includes(fileType);
    if (isPdfOrDoc) {
        return react_1.default.createElement(__1.Ds.Icon, { name: "Document", "data-testid": "document-icon" });
    }
    if (isImgFileWithoutPreview) {
        return react_1.default.createElement(__1.Ds.Icon, { name: "Photo", "data-testid": "photo-icon" });
    }
    return (react_1.default.createElement(StyledImage, { alt: `Uploaded by patient - ${file.file.name}`, src: file.dataUrl }));
};
exports.AttachedFileImagePreview = AttachedFileImagePreview;
//# sourceMappingURL=AttachedFileImagePreview.js.map